export type LeadTraffic = "paid" | "organic" | "unknown";

export type LeadClickAttribution = {
  traffic: LeadTraffic;
  campaign: string | null;
  clickId: string | null;
};

type AttributionInput = {
  gclid?: string | null;
  wbraid?: string | null;
  gbraid?: string | null;
  utmParams?: string | null;
};

const PAID_MEDIUMS = new Set([
  "cpc",
  "ppc",
  "paid",
  "paidsocial",
  "paid_social",
  "cpm",
  "display",
  "paidsearch",
]);

function present(value: string | null | undefined): string | null {
  if (value == null) return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function readUtm(utmParams: string | null | undefined): Record<string, string> {
  if (!utmParams || !utmParams.trim()) return {};
  try {
    const parsed: unknown = JSON.parse(utmParams);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    const utm: Record<string, string> = {};
    for (const [key, value] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof value !== "string") continue;
      const text = value.trim();
      if (text) utm[key.trim().toLowerCase()] = text;
    }
    return utm;
  } catch {
    return {};
  }
}

export function leadClickAttribution(input: AttributionInput): LeadClickAttribution {
  const clickId = present(input.gclid) ?? present(input.wbraid) ?? present(input.gbraid);
  const utm = readUtm(input.utmParams);
  const medium = (utm.utm_medium ?? "").toLowerCase();
  const campaign = utm.utm_campaign ?? null;

  let traffic: LeadTraffic = "unknown";
  if (clickId || PAID_MEDIUMS.has(medium)) traffic = "paid";
  else if (medium === "organic") traffic = "organic";

  return { traffic, campaign, clickId };
}
